
import "./ButtonClose.css";
import { useChatboxDispatchContext } from "../../../context/ChatboxContext";
import Close from 'jsx:../../../assets/close.svg';

const ButtonClose = () => {

    const dispatch = useChatboxDispatchContext();

    const closeChatbox = () => dispatch({ type: "openAndClose" })

    return (
        <button id="kwalys-close" onClick={closeChatbox}>
            <Close/>
        </button>
    );
};

export default ButtonClose;